export const inputsInspectorWorkStat = {
  date1: {
    key: "date1",
    label: "Период отчета с",
    type: "date",
    disabled: false,
    required: true,
    customValidation(value) {
      if (new Date(value) > new Date()) {
        return "Дата не может быть позднее текущей";
      } else if (new Date(value) < new Date("1996-09-26T00:00:00.000+03:00")) {
        return "Дата не может быть ранее 26.09.1996";
      } else {
        return true;
      }
    },
  },
  date2: {
    key: "date2",
    label: "Период отчета по",
    type: "date",
    disabled: false,
    required: true,
    customValidation(value) {
      if (new Date(value) > new Date()) {
        return "Дата не может быть позднее текущей";
      } else if (new Date(value) < new Date("1996-09-26T00:00:00.000+03:00")) {
        return "Дата не может быть ранее 26.09.1996";
      } else {
        return true;
      }
    },
  },
  inspector: {
    key: "inspector",
    label: "Инспектор",
    type: "selectWithSearch",
    disabled: false,
    searchable: true,
    required: true,
    options: [],
    customValidation(value) {
      if (value?.length > 50) {
        return "Вы выбрали максимально возможное количество";
      } else {
        return true;
      }
    },
  },
};

export const setInputsInspectorWorkStat = (type, props) => {
  if (type === "firstInit") {
    inputsInspectorWorkStat.inspector.options = props;
  }
};

export function formatDate(inputDate) {
  const parts = inputDate.split("-");
  if (parts.length !== 3) {
    return "Неверный формат даты";
  }
  const [year, month, day] = parts;
  return `${day}.${month}.${year}`;
}

export const tableHeaderCreator = (table) => {
  return Object.entries(table)
    .map(([key, value]) => ({
      Header: value,
      accessor: key,
    }))
    .filter((item) => item.Header && item.accessor !== "id");
};

export const getInputsInspectorWorkStat = () => inputsInspectorWorkStat;
